export const formatSongTitle = (songTitle: string, entryNumber: number): string => {
  const lastUnderscore = songTitle.lastIndexOf('_');
  const dotIndex = songTitle.lastIndexOf('.');
  const base = songTitle.substring(0, lastUnderscore);
  const ext = songTitle.substring(dotIndex);
  return entryNumber ? `${base}_${entryNumber}${ext}` : `${base}_${ext}`;
};